import React from "react";
import { Layout } from "../app/routes.types";
//import {Layout} from "@Milestone/component-library/src/routes";

export interface ConditionalWrapperProps {
  condition: boolean;
  wrapper?: Layout;
  children: React.ReactNode;
  extraProps: any;
}
export const Wrapper: React.FC<{}> = ({ children }) => <>{children}</>;

export const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
  extraProps,
}: ConditionalWrapperProps) => {
  const ConditionWrapper = wrapper;
  return condition && ConditionWrapper ? (
    <ConditionWrapper {...extraProps}>{children}</ConditionWrapper>
  ) : (
    <Wrapper {...extraProps}>{children}</Wrapper>
  );
};
